<div class="load-tracking-overview">
    <div class="overview-settings-all">
        <div class="overview-settings-left">
            <div class="overview-setting bucket-switcher" *ngIf="!showBucket" (click)="showBucketChange.emit(true)">
                <i class="fas fa-filter fa-2x"></i>
                <i class="fas fa-chevron-right fa-x"></i>
            </div>
            <div class="overview-setting mode-switcher" (click)="switchMode()">
                <i class="far fa-map fa-2x"></i>
                <span [i18n]="'realtime-tracking.load-tracking-overview.options.map'"></span>
            </div>
        </div>
    </div>
    <div class="trips-stats-container">
        <div class="trips-status-title" [i18n]="'realtime-tracking.load-tracking-overview.status.title'"></div>
        <div class="trips-status-stats">
            <div class="trips-status trips-status-ongoing _IN_PROGRESS"
                 [class._active]="quickFilter===QuickFilter.IN_PROGRESS"
                 (click)="switchQuickFilter(QuickFilter.IN_PROGRESS)">
                <div class="status-stat">{{ stats.inProgress }}</div>
                <div class="status-title" [i18n]="'realtime-tracking.load-tracking-overview.status.ongoing'"></div>
            </div>
            <div class="trips-status trips-status-finish-today _LIKELY_LATE"
                 [class._active]="quickFilter===QuickFilter.LIKELY_LATE"
                 (click)="switchQuickFilter(QuickFilter.LIKELY_LATE)">
                <div class="status-stat">{{ stats.likelyLate }}</div>
                <div class="status-title" [i18n]="'realtime-tracking.common.trip-status.likely_late'"></div>
            </div>
            <div class="trips-status trips-status-delay _IN_PROGRESS_LATE"
                 [class._active]="quickFilter===QuickFilter.IN_PROGRESS_LATE"
                 (click)="switchQuickFilter(QuickFilter.IN_PROGRESS_LATE)">
                <div class="status-stat">{{ stats.inProgressLate }}</div>
                <div class="status-title" [i18n]="'realtime-tracking.common.trip-status.late'"></div>
            </div>
            <div class="trips-status trips-status-start-today _COMPLETED_LATE"
                 [class._active]="quickFilter===QuickFilter.COMPLETED_LATE"
                 (click)="switchQuickFilter(QuickFilter.COMPLETED_LATE)">
                <div class="status-stat">{{ stats.completedLate }}</div>
                <div class="status-title">
                    <div [i18n]="'realtime-tracking.load-tracking-overview.status.completed-late'"></div>
                    <div [i18n]="'realtime-tracking.load-tracking-overview.status.duration'"></div>
                </div>
            </div>
            <div class="trips-status trips-status-finish-today _STARTED_TODAY"
                 [class._active]="quickFilter===QuickFilter.STARTED_TODAY"
                 (click)="switchQuickFilter(QuickFilter.STARTED_TODAY)">
                <div class="status-stat">{{ stats.startedToday }}</div>
                <div class="status-title"
                     [i18n]="'realtime-tracking.load-tracking-overview.status.started-today'"></div>
            </div>
            <div class="trips-status trips-status-finish-today _COMPLETED_TODAY"
                 [class._active]="quickFilter===QuickFilter.COMPLETED_TODAY"
                 (click)="switchQuickFilter(QuickFilter.COMPLETED_TODAY)">
                <div class="status-stat">{{ stats.finishedToday }}</div>
                <div class="status-title"
                     [i18n]="'realtime-tracking.load-tracking-overview.status.completed-today'"></div>
            </div>
        </div>
    </div>
    <hr>

    <div class="overview-container">
        <div class="trips-sorts">
            <div class="title" [i18n]="'realtime-tracking.load-tracking-overview.sort.title'"></div>
            <select class="form-control" name="sort" id="sort" [(ngModel)]="sort"
                    (ngModelChange)="sortChange.emit($event)">
                <option [ngValue]="'started_at'"
                        [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.dates.pickup'"></option>
                <option [ngValue]="'completed_at'"
                        [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.dates.completion'"></option>
                <option [ngValue]="'status'" [i18n]="'realtime-tracking.common.status'"></option>
            </select>
            <i class="fas fa-lg"
               [class.chep-icon-cycle]="sort === 'status'"
               [class.fa-angle-double-down]="sort !== 'status' && sortDirection === 'ASC'"
               [class.fa-angle-double-up]="sort !== 'status' && sortDirection === 'DESC'"
               (click)="changeSortDirection()">
            </i>
            <div>
                <i class="fa fa-info-circle space-right-5"></i>
                <span [i18n]="[{target: 'innerHTML', key: 'realtime-tracking.load-tracking-overview.@selected-timezone', params: {timezone_selected: timezoneService.selectedTimeZone.abbreviation}}]"></span>
            </div>
        </div>
        <div class="trips-overview-grid ibox-content no-padding">
            <div class="table-container" #table infiniteScroll
                 [infiniteScrollThrottle]="100" [infiniteScrollUpDistance]="0"
                 [scrollWindow]="false" (scrolled)="scrolled.emit()">
                <table>
                    <thead>
                    <tr>
                        <th [i18n]="'realtime-tracking.common.trip'"></th>
                        <th>
                            <div class="status-head">
                                <span [i18n]="'realtime-tracking.common.status'"></span>
                            </div>
                        </th>
                        <th [i18n]="'realtime-tracking.common.trip-status.likely_late'"></th>
                        <th [i18n]="'realtime-tracking.load-tracking-overview.vehicle'"></th>
                        <th></th>
                        <th class="timeLineHead">
                            <div class="main-col">
                                <i class="fas fa-chevron-left fa-x" (click)="previousDay()"></i>
                                <div class="date">{{min | formatDate: 'MMMM D, YYYY'}}</div>
                                <i class="fas fa-chevron-right fa-x" (click)="nextDay()"></i>
                                <input type="date" [(ngModel)]="date" (ngModelChange)="setDay()" #datepicker
                                       [required]="true">
                            </div>
                        </th>
                        <th>
                            <div class="eta-head">
                                <div class="eta-driver"
                                     [i18n]="'realtime-tracking.load-tracking-overview.deadline'"></div>
                                <div class="eta-automatic"
                                     [i18n]="'realtime-tracking.load-tracking-overview.current-eta'"></div>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr [class._active]="trip === selectedTrip" *ngFor="let trip of displayedTrips; last as lastItem; index as i"
                        (click)="switchTrip(trip)">
                        <td class="trip-identity"
                            [popover]="salesOrderPopTemplate"
                            placement="bottom" container="body"
                            triggers="mouseenter:mouseleave">
                            <div class="trip-load-number">
                                <span class="title" [i18n]="'realtime-tracking.common.load'"></span>
                                <span class="load-number">{{ trip.loadNumber }}</span>
                            </div>
                            <div class="trip-delivery-number">
                                <span class="title" [i18n]="'realtime-tracking.common.delivery'"></span>
                                <div class="delivery-number">
                                    <span *ngFor="let number of trip.deliveryNumbers">{{ number }}</span>
                                </div>
                            </div>
                            <ng-template #salesOrderPopTemplate>
                                <chp-delivery-and-sales-order-numbers
                                    [deliveryNumbers]="trip.deliveryNumbers"
                                    [salesOrderNumbers]="trip.getSalesOrderNumbers()">
                                </chp-delivery-and-sales-order-numbers>
                            </ng-template>
                        </td>
                        <td (click)="setDayToTripEnd(trip, $event)">
                            <div class="trip-status-info">
                                <span class="trip-status" [ngClass]="[trip.status | lowercase]"
                                      [i18n]="'realtime-tracking.common.trip-status.'+trip.status | lowercase"></span>
                            </div>
                        </td>
                        <td>
                            <div class="trip-status-info">
                                <span class="trip-status" [ngClass]="tripStatus[trip.tripId] | lowercase"
                                      [i18n]="'realtime-tracking.common.trip-status.'+tripStatus[trip.tripId] | lowercase"></span>
                                <span *ngIf="tripStatus[trip.tripId] === 'LATE'" class="trip-delay"
                                      [ngClass]="tripStatus[trip.tripId] | lowercase" [i18n]="[{target: 'innerHTML', key: tripDelay[trip.tripId].key, params: { duration: tripDelay[trip.tripId].duration}}]"></span>
                            </div>
                        </td>
                        <td class="trip-vehicle-info">
                            <span class="trip-vehicle" title="{{trip.vehicle}}"><i
                                class="fas fa-truck fa-x"></i>{{ trip.vehicle }}</span>
                        </td>
                        <td class="map-icon">
                            <button
                                [i18n]="[{ target: 'attribute:title', key: 'realtime-tracking.load-tracking-overview.options.map' }]"
                                (click)="selectTripAndSeeOnMap(trip)">
                                <i class="fas fa-map-marked-alt"></i>
                            </button>
                        </td>
                        <td class="trip-state-overview">
                            <div class="trip-state-overview">
                                <div class="arrow-container">
                                    <div class="left-arrow arrow" *ngIf="tripStartBeforeDate[trip.tripId]"
                                         (click)="leftArrowClicked(trip, $event)">
                                        <i class="fas fa-chevron-left fa-x"></i>
                                    </div>
                                </div>
                                <div class="trip-overview-bar">
                                    <div class="bar-container">
                                        <div class="trip-bar" *ngIf="tripInDay[trip.tripId]"
                                             [ngClass]="tripStatus[trip.tripId] | lowercase"
                                             [title]="tripRange[trip.tripId]"
                                             [ngStyle]="{
                                                    'left': tripStartPosition[trip.tripId]+'%',
                                                    'width': tripWidth[trip.tripId]+'%'
                                             }">
                                            <i class="fas fa-flag"
                                               *ngIf="!tripEndAfterDate[trip.tripId] && (trip.status === TripStatus.COMPLETED  || trip.status === TripStatus.EXPIRED) && tripWidth[trip.tripId] > 0"></i>
                                        </div>
                                        <div class="remaining" [ngClass]="tripStatus[trip.tripId] | lowercase"
                                             [title]="tripRange[trip.tripId]"
                                             *ngIf="tripInDay[trip.tripId] && tripRemaining[trip.tripId] > 0"
                                             [ngStyle]="{
                                                    'left': tripStartPosition[trip.tripId]+'%',
                                                    'width': clamp(0, tripRemaining[trip.tripId]-tripStartPosition[trip.tripId], 100-tripStartPosition[trip.tripId])+'%'
                                             }">
                                        </div>
                                        <div class="planning" *ngIf="planningInDay[trip.tripId]"
                                             [title]="planningRange[trip.tripId]"
                                             [ngStyle]="{
                                                    'left': planningStart[trip.tripId]+'%',
                                                    'right': planningEnd[trip.tripId]+'%'
                                             }">
                                        </div>
                                        <i class="driver-eta fa fa-truck"
                                           *ngIf="tripEtaPosition[trip.tripId] != -1 && trip.latestEtaOrigin() === EtaEmitter.DRIVER"
                                           [ngStyle]="{'left': tripEtaPosition[trip.tripId]+'%'}"
                                           [i18n]="[{ target: 'attribute:title', key: 'realtime-tracking.load-tracking-overview.legend.eta-driver', params: { eta: tripEtaDisplay[trip.tripId]} }]">
                                        </i>
                                        <i class="automatic-eta fas fa-stopwatch"
                                           *ngIf="tripSecondaryEtaPosition[trip.tripId] != -1 && trip.latestEtaOrigin() === EtaEmitter.CMBL_AUTOMATIC_ETA"
                                           [ngStyle]="{'left': tripSecondaryEtaPosition[trip.tripId]+'%'}"
                                           [i18n]="[{ target: 'attribute:title', key: 'realtime-tracking.load-tracking-overview.legend.eta-auto', params: { eta: tripEtaDisplay[trip.tripId]} }]">
                                        </i>
                                        <i class="fas fa-flag-checkered deadline"
                                           *ngIf="tripDeadlinePosition[trip.tripId] != -1"
                                           [ngStyle]="{'left': tripDeadlinePosition[trip.tripId]+'%'}"
                                           [i18n]="[{ target: 'attribute:title', key: 'realtime-tracking.load-tracking-overview.legend.deadline', params: { deadline: tripDeadlineDisplay[trip.tripId]} }]"></i>
                                    </div>
                                </div>
                                <div class="arrow-container">
                                    <div class="right-arrow arrow" *ngIf="tripEndAfterDate[trip.tripId]"
                                         (click)="rightArrowClicked(trip, $event)">
                                        <i class="fas fa-chevron-right fa-x"></i>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td  class="etasContainer"
                             [popover]="tripInfoPopTemplate"
                             placement="bottom" container="body"
                             (onShown)="selectTripTimezone(trip.timezone)"
                             triggers="mouseenter:mouseleave">
                            <div class="etas">
                                <div class="trip-deadline" [ngClass]="tripStatus[trip.tripId] | lowercase">
                                    <i class="fas fa-industry"></i>
                                    {{ tripDeadlineDisplay[trip.tripId] }}
                                </div>
                                <div class="trip-current-eta">
                                    <i [ngClass]="[trip.latestEtaOrigin() === EtaEmitter.CMBL_AUTOMATIC_ETA ? 'fas fa-stopwatch ' : 'fa fa-truck ']"></i>
                                    {{ tripEtaDisplay[trip.tripId] }}
                                </div>
                            </div>
                            <ng-template #tripInfoPopTemplate let-pop="popover">
                                <app-trip-info
                                    [info]="tripInfo[trip.tripId]">
                                </app-trip-info>
                            </ng-template>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="trips-grid-scale" [class.with-scroll]="isTableScrollable">
                <div class="scale-container">
                    <div class="scale" *ngFor="let scale of scales; let i = index"
                         [ngStyle]="{'left': scalePosition[i]+'%'}">
                        {{ scale }}
                        <div class="scale-line"></div>
                    </div>
                    <div class="actual-time-scale" *ngIf="nowOnDate" [ngStyle]="{'left': nowPosition+'%'}">
                        {{now | formatDate: 'LT'}}
                        <div class="actual-time-line"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
